module.exports = __webpack_public_path__ + "img/homepage-github.94ee56d0.svg";